import type { PairingState } from "@wodiary/shared";

/**
 * `PairingState` → 界面文案。
 *
 * 映射写在**一处**：五个状态在首页卡片、配对页、设置页都会出现，散在各处
 * 写文案迟早会说出两个不一致的说法（spec §6.3 把配对状态定为 `Pairing`
 * 的唯一 owner，界面只负责渲染）。
 */
export interface PairingCopy {
  /** 一句话说明当前处在哪一格。 */
  title: string;
  description: string;
  /** 主按钮文案；`null` = 没有主按钮。 */
  action: string | null;
}

export const PAIRING_COPY: Record<PairingState, PairingCopy> = {
  unpaired: {
    title: "还没有配对",
    description:
      "生成一个 6 位配对码给 TA，或输入 TA 给你的码。配对前双方都读不到对方的任何日记。",
    action: "生成配对码",
  },
  awaiting_partner: {
    title: "把这串码给 TA",
    description:
      "配对码 24 小时内有效，只能用一次。TA 在自己的设备上输入后，你还需要再确认一次。",
    action: "重新生成",
  },
  awaiting_my_confirm: {
    title: "{partner} 已经输入了你的配对码",
    description:
      "确认之后你们就配对成功了，此后双方可以读到彼此共享的日记。各自的私密日记仍然只属于自己。",
    action: "确认配对",
  },
  awaiting_partner_confirm: {
    title: "等待 {partner} 确认",
    description:
      "你已经输入了配对码。TA 再确认一次后，配对才会生效 —— 在那之前双方仍然读不到对方任何日记。",
    action: null,
  },
  active: {
    title: "已与 {partner} 配对",
    description: "双向授权中。你们各自写的私密日记仍然只属于自己。",
    action: null,
  },
};

export function pairingCopy(
  state: PairingState,
  partnerUsername?: string,
): PairingCopy {
  const copy = PAIRING_COPY[state];
  const partner = partnerUsername ?? "TA";
  return {
    title: copy.title.replace("{partner}", partner),
    description: copy.description.replace("{partner}", partner),
    action: copy.action,
  };
}
